import { Button } from '@servicetitan/design-system';
import styled from 'styled-components';

export const RemoveButton = styled(Button)`
  // To keep the button in line with the input fields
  margin-top: 22px;
`;
